export const coachFilteredValue = () => document.getElementById("coach").value;

export const setNumberOfPages = (dataTable) => {
  const api = dataTable.api();
  const currentPage = api.page() + 1;
  const totalPages = api.page.info().pages;
  const settings = dataTable.fnSettings();
  const tableWrapper = $(settings.nTableWrapper)[0];
  tableWrapper.querySelector(".dataTables_paginate > span").innerHTML = `${currentPage} / ${totalPages}`;
};

export const toggleColumnVisibility = (dataTable, columnIndex, visible) => {
  dataTable.api().column(columnIndex).visible(visible);
};

export const retrieveFlowRow = (tablePrefix, flowId) => {
  return document.getElementById(`${tablePrefix}_table_row_${flowId}`);
};

export const retrieveFlowCheckbox = (tablePrefix, flowId) => {
  return document.getElementById(`${tablePrefix}_cb_id_${flowId}`);
};
